import React from 'react';
import styled from 'styled-components';

import { FlexRow, formatHash, SvgIcon, Text } from '@make-software/cspr-ui';
import { BodyText } from '@block-explorer/ui';

import { getRouteDetails, useCustomHistory } from '../../router/utils';
import { useTranslation } from 'react-i18next';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';
import { useGetCasperNetwork } from '../../services/casper-network-context.tsx';

const StyledFlexRow = styled(FlexRow)(({ theme }) => ({
  cursor: 'pointer',
}));

const StyledSvgIcon = styled(SvgIcon)(({ theme }) => ({
  color: theme.styleguideColors.contentBlue,
}));

/* eslint-disable-next-line */
export interface PrevPageHeaderProps {}

export function PrevPageHeader(props: PrevPageHeaderProps) {
  const history = useCustomHistory();
  const { t } = useTranslation();
  const { networkMajorVersion } = useGetCasperNetwork();

  const { allowedGoBack, prevRouteMatch } = history.location.state || {};

  if (!allowedGoBack || prevRouteMatch == null) {
    return null;
  }

  const { name, params } = getRouteDetails(
    prevRouteMatch,
    t,
    networkMajorVersion
  );

  const hash = params.publicKey || params.id || params.token_id || '';
  const { prefix, hash: hashWithoutPrefix } =
    deriveSplitDataFromNamedKeyValue(hash);

  const handleClick = (ev) => {
    ev.stopPropagation();
    history.goBack();
  };

  return (
    <StyledFlexRow align="center" onClick={handleClick}>
      <StyledSvgIcon src="assets/icons/ic-arrow-with-tail.svg" marginRight />
      <BodyText size={1} scale={'sm'} variation="blue">
        {name}{' '}
        <Text monotype>
          {prefix}
          {formatHash(hashWithoutPrefix)}
        </Text>
      </BodyText>
    </StyledFlexRow>
  );
}

export default PrevPageHeader;
